<div class="simple-card">
  <div class="form-group search-types">
    @for (type of searchtypes; track type) {
      <div class="form-check">
        <input
          id="subscriptiontype-{{ type }}"
          class="form-check-input"
          role="radio"
          type="radio"
          aria-checked="true"
          [value]="type"
          name="searchType"
          (click)="setSearchType(type)"
          [checked]="type === currentSearchType"
          />
          <label class="form-check-label form-radio-label" for="subscriptiontype-{{ type }}">
            {{ 'quotes.searchTypes.' + type | cxTranslate }}
          </label>
        </div>
      }
    </div>

    @if (currentSearchType === SEARCH_TYPE.BASIC) {
      <basic-search></basic-search>
    }

    @if (currentSearchType === SEARCH_TYPE.ADVANCED) {
      <advanced-search></advanced-search>
    }
  </div>

  <div class="m-t-20">
    <product-list (_onChangeSearchType)="setSearchType($event)"></product-list>
  </div>
